var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.MI=require("moment");module.exports=$CLJS.MI;